import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=68520322&scoped=true&"
import script from "./ProductType.vue?vue&type=script&lang=js&"
export * from "./ProductType.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/productType.css?vue&type=style&index=0&id=68520322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68520322",
  null
  
)

export default component.exports